import fetchWithAuth from './fetchWithAuth';
import { apiConfig } from '../config';

export async function fetchMealPlan(weekStart: Date) {
  const iso = weekStart.toISOString();
  const plan = await fetchWithAuth(`/api/meal-plan?weekStart=${iso}`);
  return plan.entries; // array of { id, day, servings, recipe }
}
